import script from "./goRinSyo0085.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0085.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0085.vue?vue&type=style&index=0&id=7d5afc5f&lang=scss"

const __exports__ = script;

export default __exports__